import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f52e40e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-width text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "2",
  width: "28%"
}, "Nutrientes", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Base da Fórmula", -1))
const _hoisted_4 = { colspan: "2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, "Forma de Aplicação:", -1))
const _hoisted_6 = { colspan: "9" }

import { Category } from '@/models/category';
import { CategoryFormula } from '@/models/category-formula';
import { Formula } from '@/models/formula';
import { FormulaSubstance } from '@/models/formula-substance';
import { plainToInstance } from 'class-transformer';
import { Substance } from '@/models/substance';
import { computed, ref, watch, onMounted } from 'vue';
import {
  FormulaForm,
  getEmptyFormulaForm,
  getFormByInstance,
} from '@/views/admin/formulas/models/formula-form';
import { parse } from 'mustache';
import store from '@/store';
import useQuasar from 'quasar/src/composables/use-quasar.js';;

interface Props {
  category: Category | null;
  formula?: Formula | null;
  formulas: Formula[];
  substances: Substance[];
  index: number;
  formula_usada?: CategoryFormula[] | null;
}

interface Emits {
  (e: 'sendDataToTablesComponent', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    category: null,
    formula: null,
    formulas: null,
    substances: null,
    index: null,
    formula_usada: null
  },
  emits: ["sendDataToTablesComponent"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'sendDataToTablesComponent', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  category: Category | null;
  formula?: Formula | null;
  formulas: Formula[];
  substances: Substance[];
  index: number;
  formula_usada?: CategoryFormula[] | null;
}

const quasar = useQuasar();

let formulaId = ref<number | null >(null);
const dose = ref<number | undefined>(0);
const application = ref<string | undefined>('');
const dosage = 0;




//Caso nesse rela
const id_formula_recovered_array = computed(() => 
  props.formula_usada?.filter((formula, index) => index == (props.index - 1))
              .map((formula) => formula.formula_id)
);
const dose_formula_recovered_array = computed(() => 
  props.formula_usada?.filter((formula, index) => index == (props.index - 1))
              .map((formula) => formula.dose)
);
const application_formula_recovered_array = computed(() => 
  props.formula_usada?.filter((formula, index) => index == (props.index - 1))
              .map((formula) => formula.application)
);

const id_formula_recovered = id_formula_recovered_array.value?.toString();
const dose_formula_recovered = dose_formula_recovered_array.value?.toString();
const application_formula_recovered = application_formula_recovered_array.value?.toString();

//Caso haja dados salvos nesse Teste ele aplicara nos formularios
onMounted(() => {
  if(id_formula_recovered){
      formulaId.value = parseInt(id_formula_recovered);
      application.value = application_formula_recovered;
      dose.value = parseInt(dose_formula_recovered);
      getAddedSubstances(id_formula_recovered, dose_formula_recovered, application_formula_recovered);
  }
});
//Caso após settados os valores precisem ser alterados
watch( formulaId, (newValue, oldValue) => {
  formulaId.value = newValue;
});

/* const thisTableId = props.index;
const substances = props.substances; */

const formData = ref<FormulaForm>(getEmptyFormulaForm());

const unit = computed(() => (props.category?.name === 'Tratamento de Sementes' ? 'L' : 'Kg'));

const formulasCategory = computed(() =>
  props.formulas
    .filter((formula) => formula.categoryId == props.category?.id)
    .map((formula) => ({ label: formula.name, value: formula.id }))
);

const substancesByCategory = props.formulas.filter((i) => {
  return i.categoryId == props.category?.id;
});

const onChange = (val: string) => {
  console.log('onChange');
  console.log(props.category?.name + ' - ' + val);
};

const changeName = (event: Event) => {
  console.log('changeName');
  console.log(props.category?.name + ' - ' + (event.target as HTMLTextAreaElement).value);
};

const updateValues = () => {
  console.log('entrou aqui');
};

function getSubstancesByFormula(formulaId) {
  let found;

  if (formulaId != null) {
    found = substancesByCategory.find((element) => element.id == formulaId);
  } else {
    found = undefined;
  }

  return found;
}

function getSubstancesByFormulaValue(substanceIndex, substance_value, dose) {
  let value = 0;

  if (dose != 0) {
    if (substanceIndex > 6) {
      value = substance_value * dose * 10;
    } else {
      value = (substance_value * dose) / 100;
    }
  }

  return value.toFixed(2);
}
function getAddedSubstances(formulaId, dose, application) {
  let aux = getSubstancesByFormula(formulaId);
  let substances;
  let substanceValues;
  let name = '';

  if (aux) {
    substances = aux.formulaSubstances;
    name = aux.name;
  }

  if (substances) {
    substanceValues = substances.map((formula) => ({
      substance: formula.substanceId,
      value: getSubstancesByFormulaValue(formula.substanceId, formula.value, dose),
    }));
  } else {
    substanceValues = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  }

  let result = {
    thisTableId: props.index,
    name: name,
    dose: dose,
    application: application,
    substances: substanceValues,
  };

  emit('sendDataToTablesComponent', result);
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.substances, (substance, substanceIndex) => {
          return (_openBlock(), _createElementBlock("th", {
            width: "6%",
            key: substanceIndex
          }, _toDisplayString(substance.utf8Code) + " (" + _toDisplayString(substance.unit) + ") ", 1))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _hoisted_3,
        (getSubstancesByFormula(_unref(formulaId)))
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getSubstancesByFormula(_unref(formulaId))
              .formulaSubstances, (substance, substanceIndex) => {
              return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance.value), 1))
            }), 128))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (substance) => {
              return _createElementVNode("td", {
                key: substance.index
              }, " 0 ")
            }), 64))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_4, [
          _createVNode(_component_q_select, {
            outlined: "",
            clearable: "",
            modelValue: _unref(formulaId),
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (_isRef(formulaId) ? (formulaId).value = $event : formulaId = $event)),
              _cache[1] || (_cache[1] = (val) => getAddedSubstances(val, dose.value, application.value))
            ],
            label: "Tipo",
            "lazy-rules": "",
            options: _unref(formulasCategory),
            "emit-value": "",
            "map-options": ""
          }, null, 8, ["modelValue", "options"])
        ]),
        (getSubstancesByFormula(_unref(formulaId)))
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getSubstancesByFormula(_unref(formulaId))
              .formulaSubstances, (substance, substanceIndex) => {
              return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(getSubstancesByFormulaValue(substanceIndex, substance.value, dose.value)), 1))
            }), 128))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (substance) => {
              return _createElementVNode("td", {
                key: substance.index
              }, _toDisplayString(0))
            }), 64))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createElementVNode("span", null, "Dose (" + _toDisplayString(_unref(unit)) + "/ha ):", 1)
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_q_input, {
            modelValue: dose.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dose).value = $event)),
            type: "number",
            square: "",
            dense: "",
            debounce: "500",
            "lazy-rules": "",
            onUpdate: updateValues,
            rules: [(val) => (val && val.length > 0) || 'Informe dosagem!'],
            onChange: _cache[3] || (_cache[3] = ($event: any) => (getAddedSubstances(_unref(formulaId), dose.value, application.value)))
          }, null, 8, ["modelValue", "rules"])
        ]),
        _hoisted_5,
        _createElementVNode("td", _hoisted_6, [
          _createVNode(_component_q_input, {
            modelValue: application.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((application).value = $event)),
            type: "text",
            square: "",
            dense: "",
            debounce: "500",
            "lazy-rules": "",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (getAddedSubstances(_unref(formulaId), dose.value, application.value)))
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}
}

})